/**
 * /settings/custom-tracking-domain — operator page for FS-674.
 *
 * Declares a TanStack Router route and renders the
 * `CustomTrackingDomainPage` feature. The root wire-up picks this up from
 * `router.tsx` on a later pass.
 */

import { createRoute, Link } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { CustomTrackingDomainPage } from "@/features/custom-tracking-domain/CustomTrackingDomainPage";

export const settingsCustomTrackingDomainRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/settings/custom-tracking-domain",
	component: SettingsCustomTrackingDomainRoute,
});

export default settingsCustomTrackingDomainRoute;

export function SettingsCustomTrackingDomainRoute() {
	return (
		<div className="flex flex-col">
			<nav
				aria-label="Breadcrumb"
				className="mx-auto w-full max-w-5xl px-6 pt-10 text-sm text-zinc-500 sm:pt-16"
			>
				<ol className="flex flex-wrap items-center gap-1">
					<li>
						<Link
							to="/"
							className="rounded-[6px] px-1 py-0.5 hover:bg-zinc-100 hover:text-zinc-900"
						>
							Dashboard
						</Link>
					</li>
					<li aria-hidden="true" className="text-zinc-300">
						/
					</li>
					<li>
						<span className="rounded-[6px] px-1 py-0.5">Settings</span>
					</li>
					<li aria-hidden="true" className="text-zinc-300">
						/
					</li>
					<li className="text-zinc-900">Custom tracking domain</li>
				</ol>
			</nav>

			<CustomTrackingDomainPage />
		</div>
	);
}

// Named export for the root wire-up cycle.
export { SettingsCustomTrackingDomainRoute as SettingsCustomTrackingDomainPage };
